(function () {
  "use strict";

  function stripDigits(v) {
    return v.replace(/\D/g, "");
  }

  function validAbn(v) {
    var d = stripDigits(v);
    if (d.length !== 11 || d[0] === "0") return false;
    var w = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    var sum = (parseInt(d[0], 10) - 1) * w[0];
    for (var i = 1; i < 11; i++) sum += parseInt(d[i], 10) * w[i];
    return sum % 89 === 0;
  }

  function validAcn(v) {
    var d = stripDigits(v);
    if (d.length !== 9) return false;
    var w = [8, 7, 6, 5, 4, 3, 2, 1];
    var sum = 0;
    for (var i = 0; i < 8; i++) sum += parseInt(d[i], 10) * w[i];
    var check = (10 - (sum % 10)) % 10;
    return check === parseInt(d[8], 10);
  }

  function validNzbn(v) {
    var d = stripDigits(v);
    if (d.length !== 13) return false;
    var sum = 0;
    for (var i = 0; i < 12; i++) sum += parseInt(d[i], 10) * (i % 2 === 0 ? 1 : 3);
    var check = (10 - (sum % 10)) % 10;
    return check === parseInt(d[12], 10);
  }

  function validateBusinessNumber(value, country) {
    var d = stripDigits(value);
    if (country === "NZ") {
      if (d.length !== 13 || !validNzbn(value)) {
        return "NZBN must be 13 digits with a valid checksum.";
      }
      return null;
    }
    if (d.length === 11) {
      if (!validAbn(value)) return "ABN must be 11 digits with a valid checksum.";
      return null;
    }
    if (d.length === 9) {
      if (!validAcn(value)) return "ACN must be 9 digits with a valid checksum.";
      return null;
    }
    return "Australian Business Number must be 11 digits (ABN) or 9 digits (ACN).";
  }

  document.querySelectorAll("[data-wholesale-form]").forEach(initWholesaleForm);

  function initWholesaleForm(root) {
    var form = root.querySelector("[data-wholesale-form-el]");
    var submitBtn = root.querySelector("[data-wholesale-submit]");
    var successMsg = root.querySelector("[data-wholesale-success]");
    var errorMsg = root.querySelector("[data-wholesale-error]");
    var errorText = root.querySelector("[data-wholesale-error-text]");
    var endpoint = root.getAttribute("data-endpoint");
    var referralOtherToggle = form.querySelector(
      "[data-wholesale-referral-other-toggle]",
    );
    var referralOtherInput = form.querySelector(
      "[data-wholesale-referral-other]",
    );
    var abnInput = form.querySelector('[name="abn_acn_nzbn"]');
    var countrySelect = form.querySelector('[name="country"]');
    var abnError = form.querySelector("[data-wholesale-abn-error]");

    form
      .querySelectorAll('input[name="referral_source"]')
      .forEach(function (radio) {
        radio.addEventListener("change", function () {
          var showOther = referralOtherToggle && referralOtherToggle.checked;
          referralOtherInput.hidden = !showOther;
          referralOtherInput.required = !!showOther;
        });
      });
    if (abnInput && countrySelect) {
      abnInput.addEventListener("blur", function () {
        showAbnError(null);
        if (!abnInput.value.trim()) return;
        var err = validateBusinessNumber(abnInput.value.trim(), countrySelect.value);
        if (err) showAbnError(err);
      });
      countrySelect.addEventListener("change", function () {
        showAbnError(null);
        if (abnInput.value.trim()) {
          var err = validateBusinessNumber(abnInput.value.trim(), countrySelect.value);
          if (err) showAbnError(err);
        }
      });
    }

    function showAbnError(message) {
      if (!abnError) return;
      if (message) {
        abnError.textContent = message;
        abnError.hidden = false;
      } else {
        abnError.textContent = "";
        abnError.hidden = true;
      }
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      hide(errorMsg);
      hide(successMsg);

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var recaptchaField = form.querySelector(".g-recaptcha");
      var recaptchaToken = "";
      if (recaptchaField && window.grecaptcha) {
        recaptchaToken = window.grecaptcha.getResponse();
        if (!recaptchaToken) {
          showError("Please complete the reCAPTCHA check.");
          return;
        }
      }

      if (abnInput && countrySelect) {
        var abnErr = validateBusinessNumber(
          abnInput.value.trim(),
          countrySelect.value,
        );
        if (abnErr) {
          showError(abnErr);
          if (abnInput) abnInput.focus();
          return;
        }
      }

      if (!endpoint) {
        showError(
          "This form is not yet configured. Please contact us directly.",
        );
        return;
      }

      var payload = {
        first_name: value(form, "first_name"),
        last_name: value(form, "last_name"),
        trading_name: value(form, "trading_name"),
        email: value(form, "email"),
        country: value(form, "country"),
        phone_country_code: value(form, "phone_country_code"),
        phone: value(form, "phone_country_code") + value(form, "phone"),
        abn_acn_nzbn: value(form, "abn_acn_nzbn"),
        business_type: value(form, "business_type"),
        business_notes: value(form, "business_notes"),
        consent: form.querySelector('[name="consent"]').checked,
        recaptcha_token: recaptchaToken,
      };

      setLoading(true);

      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            setLoading(false);
            if (window.grecaptcha) window.grecaptcha.reset();
            var serverMsg =
              result.data && result.data.message
                ? result.data.message
                : "";
            // Server đã phân loại: safe (EMAIL/PHONE/ALREADY, Validation) → message cụ thể
            // infra → generic "We could not create your account... (ref: ...)"
            showError(serverMsg || "We could not create your account. Please try again shortly.");
            return;
          }
          form.hidden = true;
          var data = result.data || {};
          var converted = data.converted === true;
          var staffNotified = data.staff_notified !== false;

          if (converted) {
            if (successMsg) {
              var existing = successMsg.getAttribute("data-default-text") || successMsg.innerHTML;
              successMsg.setAttribute("data-default-text", existing);
              successMsg.innerHTML =
                "<p>Your existing account has been upgraded to wholesale. " +
                "Please <a href=\"/account/login\">sign in</a> with your usual email and password.</p>";
            }
          } else {
            if (successMsg) {
              var existingDefault = successMsg.getAttribute("data-default-text") || successMsg.innerHTML;
              successMsg.setAttribute("data-default-text", existingDefault);
              successMsg.innerHTML =
                "<p>Application received — check your email to activate your account.</p>" +
                "<p>If you don't receive an email within a few minutes, check your spam folder " +
                "or contact us at sales@cloudlinen.com.au.</p>";
            }
          }

          if (!staffNotified) {
            if (successMsg) {
              successMsg.innerHTML +=
                "<p style=\"margin-top:1rem;color:#b00;\">We couldn't notify our team automatically — " +
                "please also email us at sales@cloudlinen.com.au to confirm your application.</p>";
            }
          }

          show(successMsg);
          setLoading(false);
        })
        .catch(function () {
          setLoading(false);
          if (window.grecaptcha) window.grecaptcha.reset();
          showError(
            "We could not create your account. Please try again shortly. If this continues, contact sales@cloudlinen.com.au.",
          );
        });
    });
    function setLoading(isLoading) {
      submitBtn.disabled = isLoading;
      submitBtn.textContent = isLoading ? "Submitting…" : "Submit";
    }

    function showError(message) {
      errorText.textContent = message;
      show(errorMsg);
      errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function value(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : "";
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function hide(el) {
    if (el) el.hidden = true;
  }
})();
